module.exports = __webpack_public_path__ + "static/media/animatedSplashScreen720.b21e86d3.mp4";